export const templateTypeSettings = {
    badge: {
        viewPortSize: {
            width: 800,
            height: 800,
        },
    },
    certificate: {
        viewPortSize: {
            width: 800,
            height: 619,
        },
    },
};
export const onTemplateType = (owner, onSystemTemplate, onOrganizationTemplate) => (owner === undefined ? onSystemTemplate() : onOrganizationTemplate(owner));
export const BRANDING_GROUP = 'branding';
const BRANDING_PREFIX = 'brand#';
export const isBranded = (definition) => definition['template'].find((param) => param.group === BRANDING_GROUP || param.name?.startsWith(BRANDING_PREFIX));
export const shouldBeBranded = (free, definition) => free && !isBranded(definition);
//# sourceMappingURL=utils.js.map